<script>
export default {
  data: vm => ({
    errorMessages: [
      {
        email: '',
        cpf: '',
      },
    ],
    requiredRules: [
      v => {
        if (v) return true;
        const msg = 'Campo obrigatório';
        return msg;
      },
    ],
    emailRules: [
      v => {
        if (!!v && v.length > 0) return true;
        const msg = 'Campo obrigatório';
        return msg;
      },
      v => {
        if (
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          )
        )
          return true;
        const msg = 'Email inválido';
        return msg;
      },
    ],
    passwordRules: [
      v => {
        if (v) return true;
        const msg = 'Campo obrigatório';
        return msg;
      },
      v => {
        if (v.length > 5) return true;
        const msg = 'Senha tem que ter pelo menos 6 caracteres';
        return msg;
      },
    ],
    cpfRules: [
      v => {
        if (v) return true;
        const msg = 'Campo obrigatório';
        return msg;
      },
      cpf => {
        const msg = 'CPF inválido';
        if (
          !cpf ||
          cpf.length !== 11 ||
          cpf === '00000000000' ||
          cpf === '11111111111' ||
          cpf === '22222222222' ||
          cpf === '33333333333' ||
          cpf === '44444444444' ||
          cpf === '55555555555' ||
          cpf === '66666666666' ||
          cpf === '77777777777' ||
          cpf === '88888888888' ||
          cpf === '99999999999'
        )
          return msg;
        let soma = 0;
        let resto;
        for (let i = 1; i <= 9; i++)
          soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.substring(9, 10))) return msg;
        soma = 0;
        for (let j = 1; j <= 10; j++)
          soma += parseInt(cpf.substring(j - 1, j)) * (12 - j);
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.substring(10, 11))) return msg;
        return true;
      },
    ],
    dateValidRules: [
      v => {
        let date = false;
        if (!!v && v.indexOf('/') === -1 && v.length === 8) {
          const day = v.substr(0, 2);
          const month = Number(v.substr(2, 2)) - 1;
          const year = v.substr(4, 8);
          date = [year, month, day];
        }

        return vm.$moment(date).isValid() || 'Data inválida.';
      },
    ],
    rulesValidation: {
      required: value => !!value || 'Este campo é obrigatório.',
      noSpecialChars: value => {
        const alphanumericRegex = /^[a-zA-Z0-9 À-ú]+$/;
        return (
          alphanumericRegex.test(value) ||
          'Apenas letras e números são permitidos'
        );
      },
      minChar: value =>
        (!!value && value.length >= 6) || 'Mínimo de 6 caracteres.',
      maxChar: value =>
        (!!value && value.length < 255) ||
        !value ||
        'Limite de 255 caracteres.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (!!value && pattern.test(value)) || 'E-mail inválido.';
      },
      dateValid: value => {
        if (!value) return true;

        if (typeof value !== 'string' || value.length !== 10) {
          return 'Data inválida.';
        }

        const parts = value.split('/');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const date = new Date(year, month, day);
        if (
          isNaN(date.getTime()) ||
          date.getDate() !== day ||
          date.getMonth() !== month ||
          date.getFullYear() !== year ||
          date.getFullYear() > new Date().getFullYear() + 120 ||
          date.getFullYear() < new Date().getFullYear() - 120
        ) {
          return 'Data inválida.';
        }

        return true;
      },
      ageThreshold: value => {
        const date = (value || '')
          .replace(/(\d{2})(\d{2})(\d{4})/, '$3,$2,$1')
          .split(',')
          .map((x, i) => (i === 1 ? Number(x) - 1 : x));
        const yearDifference = vm.$moment().year() - vm.$moment(date).year();
        return yearDifference <= 100 && yearDifference >= 15
          ? true
          : 'Data inválida.';
      },
    },
  }),
  methods: {
    validate(type) {
      return this.$refs[type].validate();
    },
    reset(type) {
      this.$refs[type].reset();
    },
    resetValidation(type) {
      this.$refs[type].resetValidation();
    },
  },
};
</script>
